import { Component, OnInit, Input } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { SetorService } from '../../setor/setor.service';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';

@Component({
  selector: 'app-listar-setores-rotina',
  templateUrl: './listar-setores-rotina.component.html',
  styleUrls: ['./listar-setores-rotina.component.css']
})
export class ListarSetoresRotinaComponent implements OnInit {

  @Input() processoCliente: ProcessoCliente;

  public paginacao: Paginacao;
  public evento: Evento;
  public filtroPesquisaNomeSetor: string;
  public setoresCliente: SetorCliente[];
  public loading = false;
  public statusCode: number;

  constructor(
    private _comumService: ComumService,
    private _setorService: SetorService) {
    this.setoresCliente = new Array<SetorCliente>();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
  }

  ngOnInit() {
    this.loading = true;
    this.paginacao.itens = 5;
    this.paginacao.page = 1;

    this._setorService.obterSetoresClienteFromProcessoClienteHttp(this.processoCliente)
      .subscribe((setoresCliente) => {
        this.setoresCliente = setoresCliente.body;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeSetor = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/listar-setores-rotina/listar-setores-rotina.component.ts